import React from "react";

const PermissionHelper = ({ onClose }) => {
  const roles = [
    {
      title: "Admin",
      icon: "👤",
      permissions: [
        { text: "Full access to all system features", allowed: true },
        { text: "Can add/remove users and groups", allowed: true },
        { text: "Can modify permissions for all users", allowed: true },
        { text: "Can access financial reports and sensitive data", allowed: false },
      ],
    },
    {
      title: "Contributor",
      icon: "👥",
      permissions: [
        { text: "Full access to all system features", allowed: true },
        { text: "Can add/remove users and groups", allowed: true },
        { text: "Can modify permissions for all users", allowed: true },
        { text: "Can access financial reports and sensitive data", allowed: false },
      ],
    },
  ];

  return (
    <div className="absolute bottom-0 bg-black bg-opacity-50 flex items-center justify-center z-50 h-fit">
      <div className="bg-white p-6  w-full max-w-5xl">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-base font-semibold text-gray-800">All Permissions</h1>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {roles.map((role) => (
            <article
              key={role.title}
              className="bg-white border rounded-md p-5"
              aria-label={`${role.title} permissions`}
            >
              <header className="flex items-center gap-2 pb-4">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-gray-100 text-sm">
                  {role.icon}
                </div>
                <h2 className="text-sm font-semibold text-gray-800">{role.title}</h2>
              </header>
              <ul className="flex flex-col gap-3 list-none">
                {role.permissions.map((perm, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <span
                      className={`text-sm pt-[2px] ${perm.allowed ? "text-green-600" : "text-red-500"}`}
                      aria-hidden="true"
                    >
                      {perm.allowed ? "✔" : "✖"}
                    </span>
                    <p className="text-sm text-gray-700 leading-snug">{perm.text}</p>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PermissionHelper;
